// This should be a utility function, not a React component
const Enviarmail = async ({ aquien, reply_to, asunto, texto }) => {
   try {
      const response = await fetch(
         `${process.env.REACT_APP_SUPABASE_URL}/functions/v1/send-mail`,
         {
            method: "POST",
            headers: {
               "Content-Type": "application/json",
               Authorization: `Bearer ${process.env.REACT_APP_SUPABASE_ANON_KEY}`,
            },
            body: JSON.stringify({
               aquien: aquien || "customer@email.com",
               email: reply_to, // reply_to
               subject: asunto,
               message: texto,
            }),
         }
      );

      if (!response.ok) {
         console.error("Failed to send notification email");
         return { success: false, error: "Failed to send email" };
      } else {
         console.log("✅ Success notification sent");
         return { success: true, message: "Email sent successfully" };
      }
   } catch (error) {
      console.error("Error sending notification:", error);
      return { success: false, error: error.message };
   }
};

export default Enviarmail;
